import { numberWithCommas } from "util/common";

export function formatRemainingAiCredits(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return "—";
  }
  return numberWithCommas(numeric);
}

export function resolveRemainingAiCredits(plan) {
  if (!plan) return null;
  if (plan.RemainingAiCredits != null && plan.RemainingAiCredits !== "") {
    return Number(plan.RemainingAiCredits);
  }
  if (plan.ai_credits_remaining != null && plan.ai_credits_remaining !== "") {
    return Number(plan.ai_credits_remaining);
  }
  return null;
}
